import { createRouter, createWebHistory } from 'vue-router';
import LayOut from "@/components/layout/layout.vue";
import { webRoutes } from "./modules/web.js";
import { loginManager } from '@/utils/loginManager.js'

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component:() => import("../views/index.vue"),
  // }, 
  {
    name: "web",
    path: "/", // 父级路由
    component: LayOut,
    redirect: "/web/writing",
    meta: { 
      isAuth: true,
    },
    children: webRoutes,
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => { 
  if (to.meta.isAuth) {
    // 需要权限验证
    if (localStorage.getItem("loginUserToken")) { 
      // 验证通过
      next();
    } else { 
      try {
        let Obj = window.location;
        console.log(Obj.pathname, to.path); 
        // 显示登录弹框并等待结果
        if (Obj.pathname != "" && Obj.pathname != "/" && Obj.pathname !== to.path) { 
          await loginManager.show()
        } 
        // 登录成功后继续导航
        next()
      } catch {
        // 用户取消登录，跳转到首页
        next("/web/writing")
      }
    }
  } else { 
    // 不需要权限验证
    next();
  }
});
export default router;